import { z } from 'zod';

export const EstatePlanProductChoiceZod = z.union([
    z.literal('simple_product_choice'),
    z.literal('custom_product_choice'),
    z.literal('trust_product_choice'),
]);
export type EstatePlanProductChoice = z.infer<typeof EstatePlanProductChoiceZod>;

export const ProductChoiceZod = z.union([EstatePlanProductChoiceZod, z.literal('gift_trust_choice')]);
export type ProductChoice = z.infer<typeof ProductChoiceZod>;
